import { createAction, props } from '@ngrx/store';
import { CaseState } from '../../interfaces/interfaces';

export const savePatientInformations = createAction(
  '[Case] Save Patient Informations Case',
  props<{ caseObj: any }>()
);
export const savePatientInformationsSuccess = createAction(
  '[Case] Save Patient Informations Case Success',
  props<{ data: any }>()
);
export const savePatientInformationsFailure = createAction(
  '[Case] Save Patient Informations Case Failure',
  props<{ error: string }>()
);

export const setPatientInformationSuccess = (
  state: CaseState,
  { data }: { data: any }
) => {
  return {
    ...state,
    case: {
      ...state.case,
      patientInformations: {
        patientNo: data?.patientInformations?.patient?.id ?? null,
        firstName: data?.patientInformations?.firstName ?? null,
        lastName: data?.patientInformations?.lastName ?? null,
        idNumber: data?.patientInformations?.idNumber ?? null,
        unidentified: data?.patientInformations?.unidentified ?? null,
        birthDate: data?.patientInformations?.birthDate ?? null,
        age: data?.patientInformations?.age ?? null,
        bloodGroup: data?.patientInformations?.bloodGroup?.valueObject?.id
          ?.value
          ? {
              label:
                data?.patientInformations?.bloodGroup?.valueObject?.name?.value,
              value:
                data?.patientInformations?.bloodGroup?.valueObject?.id?.value,
            }
          : null,
        country:data?.patientInformations?.country?.id ? {
          label:data?.patientInformations?.country?.name,
          value:data?.patientInformations?.country?.id
        } : null,
        gender: data?.patientInformations?.gender ?? null,
        isForeignNational: data?.patientInformations?.isForeignNational ?? null,
        passportNo: data?.patientInformations?.passportNo ?? null,
        medicalRecords:
          data?.patientInformations?.medicalRecords?.map((item: any) => {
            return {
              id: item?.id,
              icdCodeId: item?.icdCode?.id,
              icdCodeName: item?.icdCode?.name,
              icdCode: item?.icdCode?.code,
              description: item?.description,
            };
          }) ?? [],
        contacts: data?.patientInformations?.contacts,
        description: data?.patientInformations?.description ?? null,
        idNumberVerified:data?.patientInformations?.idNumberVerified ?? false
      },
      patient: {
        firstName: data?.patientInformations?.firstName ?? null,
        lastName: data?.patientInformations?.lastName ?? null,
        id: data?.patientInformations?.patient?.id ?? null,
        category: data?.patientInformations?.patient?.category ?? [],
        gender: data?.patientInformations?.gender,
        age: data?.patientInformations?.age,
        contacts:data?.patientInformations?.patient?.contacts ?? [],
        addresses:data?.patientInformations?.patient?.addresses ?? data?.pickupAddress ?? [],
        specialCategoryTags: data?.patientInformations?.patient?.specialCategoryTags ?? [],
      },
      id: data?.id,
      caseType: data?.caseType,
      caseNo: data?.caseNo,
      createdAt:data?.createdAt ?? null,
      caseStatus: data?.caseStatus,
      appointmentStatus: data?.appointmentStatus,
      appointmentStartDate:data?.appointmentStartDate ?? null,
      appointmentEndDate:data?.appointmentEndDate ?? null,
      appointmentDuration:data?.appointmentDuration ?? null,
      uid:data?.uid ?? null,
      recordType:data?.recordType ?? null,
      cancelReason:data?.cancelReason?.valueObject?.id?.value ?? null,
      cancelDescription:data?.cancelDescription ?? null,
      isCaseApproved:data?.isCaseApproved ?? null,
      caseDate: data?.caseDate,
      plannedVehicle:data?.plannedVehicle ?? null,
      plannedStaff:data?.plannedStaff ?? null,
      childAppointments: data?.childAppointments ?? state.case.childAppointments ?? [],
      parentAppointment: data?.parentAppointment ?? state.case.parentAppointment ?? null,
      parentAppointmentId: data?.parentAppointmentId ?? state.case.parentAppointmentId ?? null,

    },
    loading: false,
    error: null,
  };
};
